<template>
    <div>
        <limitless-page-header v-if="!include" :loading="busy_loading" :title="title"></limitless-page-header>

        <div :class="{ 'content': !include }">
            <div v-if="busy_loading" :class="{ 'text-center': include }">
                <i class="icon-spinner2 spinner"></i>
            </div>

            <div v-else-if="!busy_loading && prod_lager">
                <div :class="{ 'card': !include }">
                    <div :class="{ 'card-body': !include }">
                        <ValidationObserver ref="prodlagerform">
                            <form @submit.prevent="saveProdLager">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div v-if="prod_lager.Typ === 3">
                                            <ValidationProvider vid="Antal" name="Antal" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>
                                                        Levererat antal:
                                                        <span v-if="prod_lager.source"> (beställt antal: {{ prod_lager.source.Antal }})</span>
                                                        <span class="text-danger"> *</span>
                                                    </label>
                                                    <input type="text" class="form-control" v-model="prod_lager.Antal" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>

                                            <ValidationProvider vid="EffectiveTS" name="Leverans mottagen" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>
                                                        Leverans mottagen:
                                                        <span v-if="prod_lager.source && prod_lager.source.EffectiveTS"> (förväntat leveransdatum: {{ formatDateTime(prod_lager.source.EffectiveTS).substring(0, 10) }})</span>
                                                        <span class="text-danger"> *</span>
                                                    </label>
                                                    <v-date-picker v-model="prod_lager.EffectiveTS" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                        <template v-slot="{ inputValue, togglePopover }">
                                                            <input class="form-control" :value="inputValue" @focus="togglePopover()" :class="{ 'border-danger':errors[0] }">
                                                        </template>
                                                    </v-date-picker>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div v-else>
                                            <ValidationProvider vid="Antal" name="Antal" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>
                                                        Beställt antal:
                                                        <span class="text-danger"> *</span>
                                                    </label>
                                                    <input type="text" class="form-control" v-model="prod_lager.Antal" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>

                                            <ValidationProvider vid="EffectiveTS" name="Förväntat leveransdatum" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Förväntat leveransdatum:</label>
                                                    <v-date-picker v-model="prod_lager.EffectiveTS" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                        <template v-slot="{ inputValue, togglePopover }">
                                                            <div class="input-group">
                                                                <input class="form-control" :value="inputValue" @focus="togglePopover()" :class="{ 'border-danger':errors[0] }">
                                                                <span class="input-group-append">
                                                                    <button class="btn btn-light" type="button" @click="prod_lager.EffectiveTS = ''"><i class="icon-cross3"></i></button>
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </v-date-picker>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>

                                        <ValidationProvider vid="ExtOrderID" name="Externt orderid" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label>Externt orderid:</label>
                                                <input type="text" class="form-control" v-model="prod_lager.ExtOrderID" v-bind:class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>

                                        <ValidationProvider vid="Kommentar" name="Notering" rules="" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label>Notering:</label>
                                                <textarea class="form-control" rows="5" v-bind:class="{ 'border-danger':errors[0] }" v-model="prod_lager.Kommentar"></textarea>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-lg-6" v-if="prod_lager.RowID > 0">
                                        <ActivityLogTable type="App\Models\ProdLager" :id="prod_lager.RowID" v-if="prod_lager.RowID > 0">
                                            Ändringshistorik
                                        </ActivityLogTable>
                                    </div>
                                    <div class="col-lg-6" v-else-if="prod_lager.RowID === 0 && prod_lager.Typ === 3 && prod_lager.source && prod_lager.Antal < prod_lager.source.Antal">
                                        <ValidationProvider vid="template" name="template" rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label class="d-block">Kommer resterande levereras senare?</label>
                                                <div class="custom-control custom-radio mb-2">
                                                    <input type="radio" class="custom-control-input" name="template" id="rdo-split-yes" v-model="split_type" value="yes">
                                                    <label class="custom-control-label" for="rdo-split-yes">Ja, flytta resterande antal till ny kommande leverans</label>
                                                </div>
                                                <div class="custom-control custom-radio mb-2">
                                                    <input type="radio" class="custom-control-input" name="template" id="rdo-split-no_adjust" v-model="split_type" value="no_adjust">
                                                    <label class="custom-control-label" for="rdo-split-no_adjust">Nej, ändra beställningen till levererat antal</label>
                                                </div>
                                                <div class="custom-control custom-radio">
                                                    <input type="radio" class="custom-control-input" name="template" id="rdo-split-no_keep" v-model="split_type" value="no_keep">
                                                    <label class="custom-control-label" for="rdo-split-no_keep">Nej, låt avvikelsen mellan leverans och beställning vara kvar</label>
                                                </div>
                                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                        <div v-if="split_type === 'yes'">
                                            <ValidationProvider vid="Antal" name="Antal" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>
                                                        Kommande antal:
                                                        <span class="text-danger"> *</span>
                                                    </label>
                                                    <input type="text" class="form-control" :value="prod_lager.source.Antal - prod_lager.Antal" v-bind:class="{ 'border-danger':errors[0] }" readonly>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                            <ValidationProvider vid="EffectiveTS" name="Nytt förväntat leveransdatum" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Nytt förväntat leveransdatum:</label>
                                                    <v-date-picker v-model="split_prod_lager.EffectiveTS" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                        <template v-slot="{ inputValue, togglePopover }">
                                                            <div class="input-group">
                                                                <input class="form-control" :value="inputValue" @focus="togglePopover()" :class="{ 'border-danger':errors[0] }">
                                                                <span class="input-group-append">
                                                                    <button class="btn btn-light" type="button" @click="split_prod_lager.EffectiveTS = ''"><i class="icon-cross3"></i></button>
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </v-date-picker>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                    <div :class="{ 'card-footer': !include }">
                        <div class="d-flex justify-content-end">
                            <limitless-button ref="btnsaveprodlager" type="button" @click="saveProdLager" :busy="busy_saving" icon="icon-floppy-disk">
                                <span v-if="prod_lager.RowID === 0 && prod_lager.Typ === 3">Kvittera</span>
                                <span v-else>Spara</span>
                            </limitless-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <i>Något gick fel när informationen skulle hämtas...</i>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import getError from '@services/ErrorHelper';
import { formatDateTime } from '@services/Helpers';
import ActivityLogTable from '@components/ActivityLogTable.vue';

export default {
    name: 'ProdLagerEditor',
    components: {
        ActivityLogTable,
        LimitlessButton,
        LimitlessPageHeader,
        VDatePicker,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
        },
        derivedId: {
            type: [Number, String],
            default: 0,
        },
        prodId: {
            type: [Number, String],
            default: 0,
        },
        include: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        busy_loading: true,
        busy_saving: false,
        prod_lager: null,
        split_type: 'no_keep',
        split_prod_lager: null,
    }),
    mounted() {
        this.getProdLager();
    },
    methods: {
        formatDateTime,
        getProdLager() {
            this.busy_loading = true;
            apiClient.get('/vue/prod_lager/' + (this.prod_lager && this.prod_lager.RowID > 0 ? this.prod_lager.RowID : this.id) + (this.derivedId > 0 ? '?derived_id=' + this.derivedId : ''))
                .then((response) => {
                    this.prod_lager = response.data;
                    if (this.prod_lager.RowID === 0 && !this.prod_lager.ProdID > 0) {
                        this.prod_lager.ProdID = this.prodId;
                    }
                    if (this.prod_lager.RowID === 0 && this.prod_lager.Typ === 3 && this.prod_lager.source) {
                        this.split_prod_lager = { RowID: 0, ...this.prod_lager.source };
                    }
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        async saveProdLager() {
            const isValid = await this.$refs.prodlagerform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/prod_lager/' + (this.prod_lager && this.prod_lager.RowID > 0 ? this.prod_lager.RowID : this.id), { ...this.prod_lager, split_type: this.split_type, split_prod_lager: this.split_prod_lager })
                    .then((response) => {
                        if (this.include) {
                            this.$emit('saved', response.data);
                        } else if (this.id !== response.data.id) {
                            window.location.href = '/prod_lager/' + response.data.RowID;
                        }
                        this.prod_lager = response.data;
                        this.$refs.btnsaveprodlager.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.prodlagerform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveprodlager.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
    },
    computed: {
        title() {
            if (this.prod_lager && this.prod_lager.Typ === 1) {
                return 'Beställningsunderlag';
            }
            return 'Inleverans';
        },
    },
};

</script>
